export default __webpack_public_path__ + "static/media/home-bg.fcaf3c81.jpg";